import React from 'react'

export default class Inicio extends React.Component {
    render() {
        return (
            <React.Fragment>
                <div className="form-group row mt-4 text-left">
                    <label className="col-3 col-md-2">Processo:</label>
                    <div className="col-9 col-md-4 mb-3">
                        <input type="text" className="form-control" 
                            name="processo"
                            {...this.props}
                            value={this.props.processo} />
                    </div>
                </div>
            </React.Fragment>
        )
    }
}